<template>
  <div class="content">
    <div class="row">
      <div class="col-8 ignore-screen">
        <h2 class="font-light">New Record</h2>
      </div>
      <div class="col-4 ignore-screen u-vertical-center u-inline-flex">
        <div class="form-group u-inline u-fill-width u-text-right">
          <back-button></back-button>
        </div>
      </div>
    </div>
    <!-- The form -->
    <server-error v-bind:error="error.serverError"></server-error>
    <div class="form-section">
      <label class="font-bold">Candidate</label>
      <div class="section-body row u-no-padding">
        <div class="col-12">
          <multiselect
            v-model="form.candidate"
            :options="allOtherUsers"
            :multiple="true"
            :close-on-select="false"
            label="name"
            :custom-label="getPilotLabel"
            :show-labels="false"
            track-by="id"
            v-bind:class="{ 'input-error': error.candidate }"
          ></multiselect>
          <span class="error">{{ error.candidate }}</span>
        </div>
      </div>
    </div>
    <div class="form-section">
      <label class="font-bold">Task</label>
      <div class="section-body row u-no-padding">
        <div class="col-12">
          <multiselect
            v-model="form.task"
            :options="tasks"
            :custom-label="getTaskLabel"
            track-by="name"
            :close-on-select="true"
            v-bind:class="{ 'input-error': error.task }"
          ></multiselect>
          <span class="error">{{ error.task }}</span>
        </div>
      </div>
    </div>
    <div class="form-section">
      <div class="section-body row">
        <div class="col-12 u-box" style="padding: 0.35em 0.4em;">
          <div class="form-ext-control form-ext-checkbox">
            <input
              id="check1"
              class="form-ext-input"
              type="checkbox"
              v-model="form.is_repeat"
            >
            <label class="form-ext-label" for="check1">
              Task is being repeated.
            </label>
          </div>
        </div>
      </div>
    </div>
    <div class="panel">
      <button class="btn-primary" v-on:click="save">
        <loading-spinner v-show="saving"></loading-spinner>
        <i class="fa-wrapper fa fa-upload pad-right" v-show="!saving"></i>
        Create
      </button>
    </div>
  </div>
</template>
<style>
.form-section {
  width: 100%;
}
</style>
<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import { debounce } from "@/functions/debounce.function";
import Multiselect from "vue-multiselect";
import BackButton from "@/components/BackButton";
import ServerError from "@/components/ServerError";
import LoadingSpinner from "@/components/LoadingSpinner";
import { getPilotLabel } from "@/functions/getPilotLabel";
import { clearFormFieldErrors } from "@/functions/clearFormFieldErrors";

export default {
  name: "record-create",
  components: {
    Multiselect,
    BackButton,
    ServerError,
    LoadingSpinner
  },
  data: function() {
    return {
      form: {},
      saving: false
    };
  },
  computed: {
    ...mapGetters("auth", ["users", "userProfile", "permissions"]),
    ...mapGetters("core", ["error"]),
    ...mapGetters("records", ["tasks"]),
    allOtherUsers: function() {
      return this.users.filter(u => u.id != this.userProfile.id);
    }
  },
  watch: {
    form: {
      // Clear errors on a field when its value is changed
      handler: debounce(function(formFields) {
        clearFormFieldErrors(formFields);
      }, 300),
      deep: true
    }
  },
  methods: {
    getPilotLabel(payload) {
      return getPilotLabel(payload);
    },
    getTaskLabel(payload) {
      return payload.code + ": " + payload.name;
    },
    validate() {
      var err = {};
      var isValid = true;
      // Ensure all fields filled out
      let required = ["candidate", "task"];
      for (let field of required) {
        if (this.form[field] == undefined) {
          err[field] = "This field is required.";
          isValid = false;
        }
      }
      // Ensure candidate != logged in User
      if (this.form.candidate) {
        for (let candidate of this.form.candidate) {
          if (candidate.id == this.userProfile.id) {
            err["candidate"] = "You cannot create a record for yourself (!)";
            isValid = false;
          }
        }
      };
      this.$store.commit("core/setError", err);
      return isValid;
    },
    async save() {
      this.saving = true;
      // Validate form data
      let isValid = this.validate();
      if (!isValid) {
        this.saving = false;
        return;
      }
      var cleanedData = {
        task_code: this.form.task.code,
        instructor: this.userProfile.id,
        is_repeat: this.form.is_repeat,
      };
      // Work out where to redirect to next
      if (this.form.candidate.length == 1) {
        cleanedData.redirect = "record-detail";
      } else {
        cleanedData.redirect = "record-index";
      };
      // Send request to the server
      for (let candidate of this.form.candidate) {
        cleanedData.candidate = candidate.id,
        this.$store.dispatch("records/createRecord", cleanedData);
      }
    }
  },
  mounted() {
    this.$store.commit("core/clearErrors");
    this.$store.commit("records/setTasks", this.$offlineStorage.get("tasks"));
    // Handle pre-selected candidates passed through an URL query
    if (Object.keys(this.$route.query).includes("candidate")) {
      let candidate = [this.users.find(u => u.id == this.$route.query.candidate)];
      Vue.set(this.form, "candidate", candidate);
      this.$router.replace({ name: "record-create" });
    };
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
